module.exports = __webpack_public_path__ + "portal-static/img/paihangbang3.1ebf9900.png";